
class PDPTest {
  isApplicableUrl() {
    return location.pathname.startsWith('/products/golf');
  }

  process() {
    let version = 'control';
    if (location.hash === '#a') version = 'a';
    // Original: 100430404
    // v.1 : 100430405
    if (convert && convert.currentData && convert.currentData.experiments && convert.currentData.experiments[100410035]) {
      // convert experiment id can be string or int depending on which pageload.
      if (parseInt(convert.currentData.experiments[100410035].variation_id) === 100430405) version = 'a';
    }

//    if (version === 'a') this.processV1();
    //console.log(convert.currentData);
  }

  processV1() {
    console.log("V1 ENABLED");

    // title change
    // document.querySelectorAll('.product__title h1').forEach(element => {
    //   element.textContent = 'Professional Indoor Putting Mat';
    //   element.classList.add('h1_tweak');
    // });

    // removing Free Swing Analysis (TODO: move to under + checkbox)
    // document.querySelectorAll('.product__title-sub.modal-golf-lessons').forEach(element => {
    //   element.classList.add('js-hidden');
    // });

    // removing price above the image
    //document.querySelector('.price__mobile-wrapper').classList.add('js-hidden');

    // removing APR module above the image
    //document.querySelector('.product__head-mobile .product__title-installments').style.display = 'none';

    // enabling thumbnails under mobile
    // - changing effects of section settings mobile_thumbnails from 'hide' to 'show'
    // document.querySelector('.product').classList.remove('product--mobile-hide');
    // document.querySelector('.product').classList.add('product--mobile-show');
    // document.querySelector('.thumbnail-slider').classList.remove('small-hide');
    // document.querySelector('.thumbnail-slider').classList.add('abtest-thumbnail-slider');
    // - changing effects of hide_mobile_slider from false to true
    // document.querySelector('.slider-buttons').classList.add('small-hide');

    // hiding valueprops from under the image
    // document.querySelector('.product__valueprops-wrapper').classList.add('js-hidden');

    // hiding default size selector
    //document.querySelector('variant-selects').classList.add('js-hidden');

    // show chips size selector
    //document.querySelector('.variant-selects__custom').classList.remove('js-hidden');

    // hiding stimpmeter
    //document.querySelector('.product__text').classList.add('js-hidden');

    // showing price under
    // document.querySelector('.price__desktop-wrapper').classList.remove('desktop');
    // document.querySelector('.price__desktop-wrapper').style.fontWeight = 'bold';

    // moving variant selector above the price
    // document.querySelector('.variant-selects__custom').parentNode.insertBefore(
    //   document.querySelector('.variant-selects__custom'),
    //   document.querySelector('.price__desktop-wrapper')
    // );

    // adding Limited time: 10% off into the price div
    // const limited = document.createElement('div');
    // limited.textContent = 'Limited time: 10% off';
    // limited.classList.add('price__limited');
    // document.querySelector('.price__desktop-wrapper .price').appendChild(limited);
    // document.querySelector('.price__desktop-wrapper .price').classList.add('price__tweaks');

    // revealing installments
    // document.querySelector('.product__title-installments.desktop').classList.remove('desktop');

    // hiding payment icons list
    // document.querySelector('.product .payment-icons').classList.add('js-hidden');

    // revealing new free-swing
    // document.querySelector('.product__free-swing').classList.remove('js-hidden');

    // revealing by golfers for golfers
    // document.querySelector('.product__for-golfers').classList.remove('js-hidden');
  }
}

class ABTestManager {
  constructor() {
    this.abtests = [
      // {
      //   test: new PDPTest(),
      //   processed: false
      // }
    ];
  }

  process(test) {
    test.processed = true;
    test.test.process();
  }

  processAll() {
    this.abtests
      .filter(test => !test.processed && test.test.isApplicableUrl())
      .forEach(test => this.process(test));
  }

  processProductSection() {
    // TODO: launch product section processors only
    this.processAll();
  }

}

window.ABTestManager = new ABTestManager();

// fallback launcher
document.addEventListener('DOMContentLoaded', function() {
  window.ABTestManager.processAll();
});